<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <b-form-group
            label="Başlık"
            label-for="title"
          >
            <validation-provider
              #default="{ errors }"
              name="Başlık"
              rules="required"
            >
              <b-form-input
                id="title"
                v-model="itemData.title"
                placeholder="Başlık"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
<!--        <b-col-->
<!--          cols="12"-->
<!--          md="6"-->
<!--        >-->
<!--          <b-form-group-->
<!--            label="Üst Kategori"-->
<!--            label-for="id_blog_categories"-->
<!--          >-->
<!--            <v-select-->
<!--              id="id_blog_categories"-->
<!--              v-model="itemData.id_blog_categories"-->
<!--              :options="dataList"-->
<!--              label="title"-->
<!--              :reduce="item => item.id"-->
<!--              placeholder="Ana Kategori"-->
<!--            />-->
<!--          </b-form-group>-->
<!--        </b-col>-->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Sıra No"
            label-for="ordering"
          >
            <validation-provider
              #default="{ errors }"
              name="Sıra No"
              rules="required"
            >
              <b-form-input
                id="ordering"
                v-model="itemData.ordering"
                placeholder="Sıra No"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BFormGroup, BFormInput, BRow, BButton,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ItemForm',
  components: {
    vSelect,
    ValidationProvider,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['blogCategories/dataItem']
    },
    dataList() {
      return this.$store.getters['blogCategories/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('blogCategories/getDataList', {
        select: [
          'blog_categories.id AS id',
          'blog_categories.title AS title',
        ],
        where: {
          'blog_categories.id_blog_categories': null,
        },
      })
    },
  },
}
</script>
